import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LOGO from '../../assets/imgs/logo-dark.svg';

import { getIP } from '../../services/external';

import { testIfLoginTokenIsValid, getCsrf } from '../../store/ducks/auth';

const Login = () => {
  const { csrf } = useSelector(state => state.auth);
  const { isLoading } = useSelector(state => state.auth);

  const [ip, setIp] = useState('Loading...');
  const [token, setToken] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    if (!csrf) dispatch(getCsrf());
  }, []);

  useEffect(() => {
    getIpFromServer();
  }, []);

  const getIpFromServer = async () => {
    try {
      const { data } = await getIP();
      console.log(data);
      setIp(data.ip);
    } catch (error) {}
  };

  const submitLoginToken = () => {
    dispatch(testIfLoginTokenIsValid(token));
  };

  return (
      <div className="login-wrapper">
        <div className="login-container">
          <img src={LOGO} />
          <span>{ip}</span>
          <input
            value={!isLoading ? token : 'Loading...'}
            onChange={e => setToken(e.target.value)}
            placeholder="Type token"
            id="token"
            name="token"
            disabled={isLoading}
            onKeyDown={e => {
              if (e.keyCode === 13 && !isLoading) {
                submitLoginToken();
              }
            }}
          />
        </div>
      </div>
  );
};

export default Login;
